module.exports = __webpack_public_path__ + "static/img/WMAP.9854134.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/buttons/WMAP.png
// module id = 8wFq
// module chunks = 18